export default {
    name: ["", ""],
    logout: ["Log Out", "ចាកចេញ"],
    headTitle: ["SF Admin Management", "SF Admin Management"],
    system: ["Ministry of Industry, Science, Technology & Innovation", "ក្រសួងឧស្សាហកម្ម វិទ្យាសាស្រ្ត បច្ចេកវិទ្យា និងនវានុវត្តន៍"],
    startDate: ["Start Date", "ថ្ងៃចាប់ផ្តើម"],
    endDate: ["End Date", "ថ្ងៃបញ្ចប់"],
    active: ["Active", "ដំណើរការ"],
    showMore: ["Show more", "បង្ហាញបន្ថែម"],
    search: ["Search", "ស្វែងរក"],
    edit: ["Edit", "កែប្រែ"],
    enable: ["Enable", "ដាក់ដំណើរការ"],
    disable: ["Disable", "បញ្ចប់ដំណើរការ"],
    delete: ["Delete", "លុបចេញ"],
    cancel: ["Cancel", "បោះបង់"],
    statusAll: ["Status (All)", "ស្ថានភាព (ទាំងអស់)"],
    typeAll: ["Type (All)", "ប្រភេទ (ទាំងអស់)"],
    type: ["Type", "ប្រភេទ"],
    update: ["Update", "ធ្វើបច្ចុប្បន្នភាព"],
    all: ["All", "ទាំងអស់"],
    status: ["Status", "ស្ថានភាព"],
    action: ["Action", "សកម្មភាព"],
    lastUpdate: ["Last Updated", "កែប្រែចុងក្រោយ"],
    settings: ["System Settings", "ការកំណត់ប្រព័ន្ធ"],
    code: ["Code", "លេខកូដ"],
    dashboard: ["Dashboard", "ទំព័រដើម"],
    user: ["User Management", "ការគ្រប់គ្រងអ្នកប្រើប្រាស់"],
    administrators: ["Administrators", "ការគ្រប់គ្រងអ្នកគ្រប់គ្រង"],
    view: ["View Detail", "មើលលម្អិត"],
    required: ["* required", "* តម្រូវបំពេញ"],
    disabled: ["Disabled", "មិនដំណើរការ"],
    systemClients: ["System Clients", "ការគ្រប់គ្រងប្រព័ន្ធបុត្រសម្ព័ន្ធ"],
    totalSuccessLogin: ["Total Successful Logins", "ចំនួនចូលប្រព័ន្ធជោគជ័យសរុប"],
    totalNewUser: ["Total New Users", "ចំនួនអ្នកប្រើប្រាស់ថ្មី"],
    totalFailLogin: ["Total Failed Logins", "ចំនួនចូលប្រព័ន្ធបរាជ័យសរុប"],
    totalRequestLogin: ["Total Request Login", "ចំនួនស្នើសុំចូលប្រព័ន្ធសរុប"],
    loginSystem: ["System Login", "ចូលប្រើប្រាស់ប្រព័ន្ធ"],
    login: ["Log In", "ចូលប្រព័ន្ធ"],
    technicalSupport: ["Technical Support", "គាំទ្រផ្នែកបច្ចេកទេស"],
    addNewAdministrator: ["Add New User", "បង្កើតអ្នកប្រើប្រាស់ថ្មី"],
    searchAdministrator: ["Search users", "ស្វែងរកអ្នកគ្រប់គ្រង"],
    editAdministrator: ["Edit Administrator", "កែប្រែព័ត៌មានអ្នកគ្រប់គ្រង"],
    userName: ["Name", "ឈ្មោះអ្នកប្រើប្រាស់"],
    userContact: ["Contact", "ទំនាក់ទំនង"],
    userLogin: ["Last Login", "ចូលប្រព័ន្ធចុងក្រោយ"],
    newUser: ["Create New User", "បង្កើតអ្នកប្រើប្រាស់ថ្មី"],
    noUser: ["No user available.", "មិនមានអ្នកប្រើប្រាស។"],
    disableUser: ["Do you want to disable this user ?", "តើអ្នកពិតជាចង់ផ្អាកដំណើរការអ្នកប្រើប្រាស់នេះពិតមែនទេ ?"],
    searchUser: ["Search User", "ស្វែងរកអ្នកប្រើប្រាស់"],
    gender: ["Gender", "ភេទ"],
    male: ["Male", "ប្រុស"],
    female: ["Female", "ស្រី"],
    genderOther: ["Other", "ផ្សេងទៀត"],
    totalLogin: ["Total Login", "ចូលប្រព័ន្ធសរុប"],
    userLastIP: ["Last Login IP", "ចូលប្រព័ន្ធ IP ចុងក្រោយ"],
    userNameLatin: ["Latin Name", "ឈ្មោះឡាតាំង"],
    


    adminName: ["Name", "ឈ្មោះអ្នកគ្រប់គ្រង"],
    adminLogin: ["Login Name", "ឈ្មោះចូលប្រព័ន្ធ"],
    adminContact: ["Contact", "ទំនាក់ទំនង"],
    adminRole: ["Role", "តួនាទី"],
    roleSuperAdmin: ["Super Administrator", "អ្នកគ្រប់គ្រងជាន់ខ្ពស់"],
    roleAdmin: ["Administrator", "អ្នកគ្រប់គ្រងទូទៅ"],
    adminUsername: ["Login Name", "ឈ្មោះចូលប្រព័ន្ធ"],
    disableAdmin: ["Do you want to delete this administrator ?", "តើអ្នកពិតជាចង់ផ្អាកដំណើរការអ្នកគ្រប់គ្រងនេះពិតមែនទេ ?"],
   
    settingName: ["Setting Name", "ឈ្មោះការកំណត់"],
    settingValue: ["Setting Data", "ទិន្នន័យកំណត់"],
    searchClient: ["Search System Clients", "ស្វែងរកប្រព័ន្ធបុត្រសម្ព័ន្ធ"],
    newClient: ["New System Client", "បង្កើតប្រព័ន្ធបុត្រសម្ព័ន្ធថ្មី"],
    clientName: ["System Client Name", "ឈ្មោះប្រព័ន្ធបុត្រសម្ព័ន្ធ"],
    noClient: ["No system clients available.", "មិនមានប្រព័ន្ធបុត្រសម្ព័ន្ធទេ។"],
    editClient: ["Edit System Client", "កែប្រែព័ត៌មានប្រព័ន្ធបុត្រសម្ព័ន្ធ"],
    clientInfo: ["System Client Information", "ព័ត៌មានប្រព័ន្ធបុត្រសម្ព័ន្ធ"],
    apiKey: ["API Key", "លេខកូដ API Key"],
    statistics: ["Overall Statistics", "ទិន្នន័យស្ថិតិសរុប"],
    statisticsToday: ["Today", "ទិន្នន័យស្ថិតិប្រចាំថ្ងៃ"],
    statisticsRange: ["Search by Date Range", "ស្វែងរកទិន្នន័យស្ថិតិ"],
    totalUser: ["Total Users", "ចំនួនអ្នកប្រើប្រាស់ទាំងអស់"],
    totalSystemClient: ["Total System Clients", "ចំនួនប្រព័ន្ធបុត្រសម្ព័ន្ធទាំងអស់"],
    totalAdmin: ["Total Administrators", "ចំនួនអ្នកគ្រប់គ្រងទាំងអស់"], 
    totalSetting: ["Total Settings", "ចំនួនការកំណត់ទាំងអស់"],
    code: ["System Code", "លេខកូដប្រព័ន្ធ"],
    updatedDate: ["Last Updated", "ថ្ងៃកែប្រែចុងក្រោយ"],
    integration: ["API Endpoint", "របៀបភ្ជាប់ API Endpoint"],
    
    createdDate: ["Created Date", "ថ្ងៃបង្កើត"],
    password: ["Password", "ពាក្យសម្ងាត់"],
    confirmPassword: ["Confirm Password", "បញ្ជាក់ពាក្យសម្ងាត់"],
    description: ["Description", "ការពិពណ៌នា"],
    phoneNumber: ["Phone Number", "លេខទូរស័ព្ទ"],
    email: ["Email", "អុីម៉ែល"],
    dob: ["Date of Birth", "ថ្ងៃខែឆ្នាំកំណើត"],
    first_name_en: ["Name (Latin)", "នាម (ឡាតាំង)"],
    last_name_en: ["Surname (Latin)", "គោត្តនាម (ឡាតាំង)"],
    first_name_km: ["Name", "នាម"],
    last_name_km: ["Surname", "គោត្តនាម"],
    govId: ["Government Official ID", "លេខប័ណ្ណមន្រ្តីរាជការ"],
    moiId: ["National ID", "លេខអត្តសញ្ញាណប័ណ្ណ"],
    editUser: ["Edit User", "កែប្រែព័ត៌មានអ្នកប្រើប្រាស់"],
    userInfo: ["User Information", "ព័ត៌មានអ្នកប្រើប្រាស់"],
    resetPassword: ["Reset Password", "ដាក់ពាក្យសម្ងាត់ឡើងវិញ"],
    clientLoginInfo: ["Login Informattion", "ព័ត៌មានអំពីរការចូលប្រព័ន្ធ"],
    time: ["times", "ដង"],
    requestLogin: ["Login Requests", "ស្នើសុំចូលប្រព័ន្ធ"],
    loginSuccess: ["Successful Logins", "ចូលប្រព័ន្ធជោគជ័យ"],
    loginFail: ["Failed Logins", "ចូលប្រព័ន្ធមិនជោគជ័យ"],
    disableClient: ["Do you want to disable this system client ?", "តើអ្នកពិតជាចង់ផ្អាកដំណើរការប្រព័ន្ធបុត្រសម្ព័ន្ធនេះមែនឬ​ ?"],
    clientNameEn: ["System Name (English)", "ឈ្មោះប្រព័ន្ធ​ (អង់គ្លេស)"],
    clientNameKm: ["System Name (Khmer)", "ឈ្មោះប្រព័ន្ធ​ (ភាសាខ្មែរ)"],
    clientHome: ["System Home URL", "អាស័យដ្ឋានទំព័រដើមរបស់ប្រព័ន្ធ"],
    clientRedirect: ["System Authentication URL", "អាស័យដ្ឋានសម្រាប់ចូលប្រព័ន្ធ"],
    clientApi: ["System Callback API", "អាស័យដ្ឋាន API របស់ប្រព័ន្ធ"],
    updateClient: ["Update System Client", "កែប្រែប្រព័ន្ធ"],
    revokeAPI: ["Revoke API Key", "បង្កើត API Key ថ្មី"],
    revokeKey: ["Revoke Private/Public Key", "បង្កើត Private/Public Key ថ្មី"],
    systemCode: ["System Code", "លេខកូដប្រព័ន្ធ"],
    userCode: ["User Code", "លេខកូដអ្នកប្រើប្រាស់"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
}





// WEBPACK FOOTER //
// ./src/config/locale.js